import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCompliance } from 'redux/actions/UserCompliance';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import ComplianceTab from "./ComplianceTab";
import Loader from 'components/loader/Loader';
import { Grid } from '@mui/material';
import DateTab from 'pages/date/Date';
import CommonFilter from 'components/commonFilter/CommonFilter';
import { complianceFilterData } from './ComplianceDocumentData';
import { debounce } from 'lodash';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';


function ComplianceTable() {
  const { tabs } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  const navigate = useNavigate();
  const tableData = useSelector((state) => state?.userCompliance?.userCompliance?.data);

  const loader = useSelector((state) => state?.userCompliance?.loading);
  const dispatch = useDispatch();
  const [type, setType] = useState(localStorage.getItem('role') === 'subVendorCompany' ? 'Driver' : 'SubVendor')
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState(params?.status ? params?.status : []);
  const [value, setValue] = useState(tabs ? tabs : '2'); // value 1 for admin ---vendorCompany
  const [registration, setRegistration] = useState('subVendorRegistration')
  const [page, setPage] = useState(params?.page ? parseInt(params?.page) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(params?.pageSize ? parseInt(params?.pageSize) : 10);
  const [search, setSearch] = useState(params?.search ? params?.search : "");
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);

  // const onInputChange = (e, data) => {
  //   console.log("input change Compliance---->", data?.id);
  //   dispatch(getCompliance({ ...filterData, locationId: data?.id })); // Fetch data based on new location
  // };

  const onInputChange = (data) => {
    //setLocValue(data);
   // setLocId(data?.id);
   //console.log("input change Compliance---->", data?.id);
  dispatch(getCompliance({ ...filterData, locationId: data?.id }));
  };

  let filterData = {
    type: registration,
    id: '',
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    pageSize: rowsPerPage,
    search: search,
    locationId: selectedLocation?.id
  };

  const typeObj = {
    valueType1: ['Vendor', 'vendorRegistration'],
    valueType2: ['SubVendor', 'subVendorRegistration'],
    valueType3: ['Driver', 'driverRegistration'],
    valueType4: ['Vehicle', 'vehicleRegistration'],
  }

  useEffect(() => {
    setValue(tabs);
    setPage(0);
    setType(typeObj[`valueType${tabs}`]?.[0])
    setRegistration(typeObj[`valueType${tabs}`]?.[1])
    filterData = { ...filterData, type: typeObj[`valueType${tabs}`]?.[1], page: 0 }
    dispatch(getCompliance(filterData))

  }, []);

  const onTabChange = (value) => {
    navigate(`/compliance/${value}`);

    setValue(value)
    setStatus([]);
    setSearch("");
    setPage(0);

    setType(typeObj[`valueType${value}`]?.[0]);
    setRegistration(typeObj[`valueType${value}`]?.[1]);

    dispatch(getCompliance({ ...filterData, type: typeObj[`valueType${value}`]?.[1], status: "", search: "", page: 0, locationId: selectedLocation?.id, }))
  }

  const onClickTableCompliance = (val) => {
    const vehicleType = val?.vehicleType ? val?.vehicleType : ""
    navigate(`/compliance/documents`, { state: { id: val?.id, status: val?.status, name: val?.submitterName, type, submitterId: val?.submitterId, vehicleType, fromSubVendorExpiry: type == 'SubVendor' } });
  };

  const onFilterChange = (val) => {
    setStatus(val);
    setPage(0);
    setSearchParams({
      ...params,
      status: val.toString(),
      page: 0,
    });
    filterData = { ...filterData, status: val.toString(), page: 0 }
    dispatch(getCompliance(filterData));
  }

  const onRestFilter = () => {
    setStatus("");
    setSearchParams({ ...params, status: '' });
    filterData = { ...filterData, status: "" }
    dispatch(getCompliance(filterData));
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSearchParams({ ...params, page: newPage });
    dispatch(getCompliance({ ...filterData, page: newPage }))
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    setSearchParams({
      ...params,
      page: 0,
      pageSize: parseInt(event.target.value),
    });
    dispatch(getCompliance({ ...filterData, page: 0, pageSize: parseInt(event.target.value) }))
  }

  const onSearch = debounce((e) => {
    setSearch(e)
    const searchFilterData = {
      ...filterData, search: e, page: 0
    }
    setSearchParams({ ...params, search: e, page: 0, pageSize: '' });
    dispatch((getCompliance(searchFilterData)))
  }, 1000)

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const complianceRoleEnum = roleAndPermissionEnum.compliance
  const accessForall = handlePermissions(roleAndPermissions, complianceRoleEnum.moduleKey, { defaultAllAccess: complianceRoleEnum.all, customAccess: complianceRoleEnum.add });

  const accessForOnlyViewSubVendor = handlePermissions(roleAndPermissions, complianceRoleEnum.moduleKey, { customAccess: complianceRoleEnum.conplianceSubVendorView });

  const accessForOnlyViewDriver = handlePermissions(roleAndPermissions, complianceRoleEnum.moduleKey, { customAccess: complianceRoleEnum.conplianceDriverView });

  const accessForOnlyViewVehicle = handlePermissions(roleAndPermissions, complianceRoleEnum.moduleKey, { customAccess: complianceRoleEnum.conplianceVehicleView });

  return (

    <div className='paddingTopBottom10'>
      <ComplianceTab
        onInputChange={onInputChange}
        defaultStatus={status}
        className="marginTop"
        tableData={tableData}
        onClickTableVendor={onClickTableCompliance}
        handleChange={onTabChange}
        value={value}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        filterdata={complianceFilterData}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        onSearch={onSearch}
        searchValue={search}
        loader={loader}
        accessForOnlyViewSubVendor={accessForOnlyViewSubVendor}
        accessForOnlyViewDriver={accessForOnlyViewDriver}
        accessForOnlyViewVehicle={accessForOnlyViewVehicle}
      />
    </div>
  )
}
export default ComplianceTable;